import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useStandardizationProjectNextPhase = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(async (id) => {
    return await axios.post(`/standardization/${id}/nextPhase`);
  });

  const nextPhase = (projectId, options) => {
    mutate(projectId, {
      onSuccess: (res) => {
        if (res.data) {
          queryClient.invalidateQueries(['standardizationProjects', { projectId: projectId }], { exact: true });
          options?.onSuccess && options.onSuccess();
          toast.success('Transitioned to the next phase!');
        } else {
          toast.error('Mark all modules as scoring completed before going to the next phase!');
        }
      },
      onError: (err) => {
        toast.error(err.message || 'Some Error occurred. Try again later.');
      },
    });
  };

  return {
    nextPhase,
    isLoading,
  };
};

export default useStandardizationProjectNextPhase;
